@if (isLoading) {
  <div id="spinner" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255, 255, 255, 0.8); display: flex; justify-content: center; align-items: center; z-index: 1000;">
    <mat-progress-spinner
      class="mat-spinner-color"
      mode="indeterminate"
    ></mat-progress-spinner>
  </div>
}

<div class="row">
  <h2 style="width: 86%; margin-left: 1rem">{{ data?.title }} Upload</h2>
  <div class="col-1">
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<hr />
<div class="row">
  <div class="col-6">
    <label class="btn btn-default p-0">
      <input type="file" multiple (change)="selectFiles($event)" multiple />
    </label>
  </div>

  <div class="col-4">
    <button
      class="btn btn-success btn-sm"
      [disabled]="!selectedFiles"
      (click)="uploadFiles()"
      >
      Upload
    </button>
  </div>
</div>

@if (message.length) {
  <div class="alert alert-secondary my-3" role="alert">
    @for (msg of message; track msg; let i = $index) {
      <ul>
        <li>{{ msg }}</li>
      </ul>
    }
  </div>
}

@if (!files?.length) {
  <div class="mt-3">No Files Uploaded Yet</div>
}

<!-- Display Download Link -->
@if (downloadedFile) {
  <div class="mt-3">
    <h4>Uploaded {{ data?.title }} </h4>
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <a [href]="downloadedFile.url" [download]="downloadedFile.name">
          Download {{ downloadedFile.name }}
        </a>
      </li>
    </ul>
  </div>
}

@if (data.title === constants.ASSESSMENT_PLAN) {
  <div class="form-group mt-3 required">
    <label class="form-control-label">
      Remarks<span class="text-red">*</span>
    </label>
    <textarea
      name="remarks"
      class="form-control"
      (input)="remarks = $event.target.value"
    ></textarea>
  </div>
}

<div class="form-group mt-5">
  <button
    style="width: 10%; float: right"
    type="submit"
    id="submit"
    class="form-submit-btn mat-raised-button"
    [disabled]="data.title === constants.ASSESSMENT_PLAN ? !files?.length || !remarks : !files?.length"
    (click)="saveFile()"
    >
    Save
  </button>
</div>
